import styled, { keyframes } from 'styled-components';

export const loadingAnimation = keyframes`
 0% { transform: rotate(0); }
 100% { transform: rotate(360deg); }
`;

const AnimatedSvg = styled.svg`
    animation: ${loadingAnimation} 1s cubic-bezier(0.5, 0.43, 0.42, 0.51) infinite;
`;

type variants = 'grey' | 'white' | 'blue';

const Loader1 = styled(AnimatedSvg)<{
  $variant?: variants;
}>`
    & > path:first-child {
        fill: ${({ theme }) => theme.colors.palette.blue_300};
    }
    
    & > path:last-child {
        fill: ${({ theme, $variant }) => theme.colors.palette[$variant === 'grey' ? 'grey_400' : 'white']};
    }
`;

type size = '2xs' | 'xs' | 'sm' | 'md' | 'lg';

const SizedLoaders = (props) => ({
    '2xs': (
        <Loader1 xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none' $variant={props.variant}>
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25C5.27208 2.25 2.25 5.27208 2.25 9ZM9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0Z'
            />
            <path
              d='M6.30828 1.60457C6.09485 1.01815 5.44205 0.709601 4.88698 0.99479C3.3321 1.79366 2.03562 3.03256 1.1668 4.56819C0.111571 6.4333 -0.243535 8.61372 0.165355 10.7173C0.574245 12.8208 1.72029 14.7095 3.39737 16.0435C4.77818 17.1418 6.44435 17.8048 8.18527 17.9631C8.80676 18.0196 9.29644 17.4889 9.27466 16.8653C9.25288 16.2416 8.72647 15.7634 8.10791 15.6808C6.9067 15.5204 5.76349 15.0379 4.80419 14.2749C3.54823 13.2758 2.68995 11.8614 2.38373 10.2861C2.07752 8.71072 2.34346 7.0778 3.13372 5.68102C3.73732 4.61416 4.61654 3.73854 5.67019 3.13984C6.21277 2.83153 6.52172 2.19099 6.30828 1.60457Z'
            />
        </Loader1>
    ),
    xs: (
        <Loader1 xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' $variant={props.variant}>
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0Z'
            />
            <path
              d='M8.22636 1.632C8.04377 1.13035 7.487 0.868154 7.00167 1.0905C4.71282 2.13911 2.8035 3.8855 1.55573 6.09092C0.148761 8.57773 -0.324713 11.485 0.220474 14.2897C0.76566 17.0944 2.29373 19.6126 4.52982 21.3913C6.51289 22.9687 8.9374 23.8727 11.4524 23.9875C11.9857 24.0119 12.4037 23.5602 12.3851 23.0267C12.3664 22.4932 11.918 22.0806 11.3851 22.048C9.33099 21.9224 7.35596 21.1691 5.73327 19.8784C3.85741 18.3862 2.57551 16.2737 2.11816 13.9208C1.6608 11.5679 2.058 9.12906 3.2383 7.04287C4.25931 5.23824 5.80835 3.79998 7.66584 2.91397C8.14768 2.68414 8.40894 2.13364 8.22636 1.632Z'
            />
        </Loader1>
    ),
    sm: (
        <Loader1 xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30' fill='none' $variant={props.variant}>
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M1.875 15C1.875 22.2487 7.75126 28.125 15 28.125C22.2487 28.125 28.125 22.2487 28.125 15C28.125 7.75126 22.2487 1.875 15 1.875C7.75126 1.875 1.875 7.75126 1.875 15ZM15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0Z'
            />
            <path
              d='M10.1803 1.75809C10.0088 1.28672 9.48619 1.04114 9.02607 1.24091C6.04344 2.53582 3.5539 4.76934 1.94467 7.61365C0.185951 10.7222 -0.405891 14.3562 0.275592 17.8621C0.957075 21.3681 2.86716 24.5158 5.66228 26.7391C8.21983 28.7735 11.3648 29.9118 14.6153 29.9951C15.1168 30.0079 15.5093 29.5845 15.4918 29.0832C15.4743 28.5819 15.0533 28.1929 14.552 28.1759C11.7342 28.0802 9.01207 27.0826 6.79308 25.3175C4.33644 23.3634 2.65767 20.5969 2.05872 17.5155C1.45976 14.4342 1.97993 11.2402 3.52567 8.50813C4.92187 6.04034 7.07206 4.09569 9.64883 2.95134C10.1073 2.74775 10.3519 2.22945 10.1803 1.75809Z'
            />
        </Loader1>
    ),
    md: (
        <Loader1 xmlns='http://www.w3.org/2000/svg' width='36' height='36' viewBox='0 0 36 36' fill='none' $variant={props.variant}>
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M3.6 18C3.6 25.9529 10.0471 32.4 18 32.4C25.9529 32.4 32.4 25.9529 32.4 18C32.4 10.0471 25.9529 3.6 18 3.6C10.0471 3.6 3.6 10.0471 3.6 18ZM18 0C8.05888 0 0 8.05888 0 18C0 27.9411 8.05888 36 18 36C27.9411 36 36 27.9411 36 18C36 8.05888 27.9411 0 18 0Z'
            />
            <path
              d='M12.4627 2.78628C12.1208 1.84698 11.077 1.35453 10.1767 1.78896C6.8881 3.37595 4.14573 5.93344 2.3336 9.13637C0.223141 12.8666 -0.487069 17.2274 0.33071 21.4346C1.14849 25.6417 3.44059 29.4189 6.79473 32.0869C9.67475 34.3778 13.1755 35.7218 16.8192 35.9613C17.8166 36.0268 18.5999 35.1792 18.565 34.1802C18.5301 33.1813 17.6892 32.4116 16.6938 32.3208C13.9138 32.0672 11.2532 31.0081 9.04811 29.2541C6.36849 27.1226 4.53733 24.1049 3.884 20.7439C3.23068 17.3828 3.79807 13.8989 5.48411 10.9188C6.87157 8.46653 8.94162 6.48782 11.4242 5.21132C12.3132 4.75424 12.8045 3.72558 12.4627 2.78628Z'
            />
        </Loader1>
    ),
    lg: (
        <Loader1 xmlns='http://www.w3.org/2000/svg' width='42' height='42' viewBox='0 0 42 42' fill='none' $variant={props.variant}>
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M3.5 21C3.5 30.665 11.335 38.5 21 38.5C30.665 38.5 38.5 30.665 38.5 21C38.5 11.335 30.665 3.5 21 3.5C11.335 3.5 3.5 11.335 3.5 21ZM21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42C32.598 42 42 32.598 42 21C42 9.40202 32.598 0 21 0Z'
            />
            <path
              d='M14.3961 2.85599C14.0766 1.97811 13.1023 1.51927 12.2529 1.90838C8.24744 3.74344 4.90612 6.79963 2.72253 10.6591C0.260332 15.011 -0.568247 20.0987 0.385829 25.007C1.3399 29.9153 4.01402 34.3221 7.92719 37.4348C11.3976 40.1952 15.6405 41.7772 20.0417 41.9782C20.9749 42.0208 21.7065 41.2303 21.6739 40.2967C21.6412 39.363 20.8564 38.6411 19.924 38.584C16.3292 38.3641 12.8729 37.0459 10.0332 34.7871C6.75046 32.1759 4.50714 28.479 3.70677 24.3615C2.9064 20.2439 3.60149 15.9758 5.66703 12.325C7.4538 9.16692 10.1646 6.64996 13.4152 5.09945C14.2584 4.69725 14.7156 3.73387 14.3961 2.85599Z'
            />
        </Loader1>
    )
});

interface LoaderProps {
    size: size;
    variant?: variants;
}

export function Loader({
    size,
    variant
}: LoaderProps) {
    return SizedLoaders({ variant })[size];
}

export const Loader2 = ({ ...props }) => {
    return (
      <AnimatedSvg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 60 60' fill='none' {...props}>
          <path fill-rule='evenodd' clip-rule='evenodd' d='M7.5 30C7.5 42.4264 17.5736 52.5 30 52.5C42.4264 52.5 52.5 42.4264 52.5 30C52.5 17.5736 42.4264 7.5 30 7.5C17.5736 7.5 7.5 17.5736 7.5 30ZM30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0Z' fill='#E9ECEF' />
          <path d='M21.0276 5.34857C20.3162 3.39384 18.1402 2.36534 16.2899 3.31597C11.107 5.97887 6.78539 10.1085 3.88933 15.2273C0.371902 21.4443 -0.811782 28.7124 0.551184 35.7243C1.91415 42.7361 5.73432 49.0316 11.3246 53.4782C15.9273 57.1394 21.4812 59.3494 27.2842 59.8769C29.3559 60.0652 30.9881 58.2964 30.9155 56.2175C30.8429 54.1386 29.0882 52.5447 27.0264 52.2694C23.0223 51.7347 19.2116 50.1264 16.014 47.5829C11.8274 44.2527 8.96651 39.5381 7.94578 34.2869C6.92506 29.0357 7.81152 23.5927 10.4457 18.9367C12.4577 15.3805 15.3885 12.4618 18.9006 10.4661C20.7092 9.43845 21.7391 7.3033 21.0276 5.34857Z' fill='#7CADEB' />
      </AnimatedSvg>
    );
};
